import { extractErrorMessage, get } from "src/helpers/api_helper"
import { IConfig, IRatingAndFeedback, IUser, ResponsePagination, ResponseRequest } from "./types"

export const getRatingAndFeedbackUsers = async (config: IConfig): Promise<ResponseRequest<ResponsePagination<IRatingAndFeedback>>> => {
    try {
        let params: any = { ...config }
        const response = await get<ResponsePagination<IRatingAndFeedback>>('/admin/ratings', { params })
        if (response.code === 200) {
            return { result: "ok", data: response.data! }
        } else { 
            return { result: "error", message: response.message } 
        }
    } catch (error) {
        const message = extractErrorMessage(error)
        return { result: "error", message }
    }
}
